/* src/app/shared/prov-plan-fac-ref-prod/prov-plan-fac-ref-prod.dialog.css */
.select-width {
  width: 100%;
}
.label-div {
  padding-top: 16px;
  width: 225px;
  height: 1px;
}
.font9 {
  font-size: 9px;
}
.font12 {
  font-size: 12px;
}
.font15 {
  font-size: 15px;
}
.pointr {
  cursor: pointer;
}
mat-form-field {
  width: 245px;
  font-size: 12px;
}
.mat-form-field-label,
.mat-input-element {
  color: rgba(255, 255, 255, 0.04) !important;
}
.radio-group {
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 10px;
  border-radius: 4px;
}
.popper-content {
  font-family:
    "Segoe UI",
    Roboto,
    sans-serif;
  font-size: 10px;
  font-style: italic;
  line-height: 1.5;
  background-color: #fefefe;
  color: #333;
  padding: 6px 8px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  max-width: 250px;
  white-space: normal;
  word-wrap: break-word;
  z-index: 1000;
}
.margin-top-5 {
  margin-top: -5px;
  margin-right: -15px;
}
.margin-top-20 {
  margin-top: -20px;
}
.error-text {
  width: 87%;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 0;
  line-height: 1.2;
  font-size: 12px;
}
/*# sourceMappingURL=prov-plan-fac-ref-prod.dialog.css.map */
